<template>
  <div class="instruction">
    <p class="instruction--number">{{ number }}</p>
    <p class="instruction--text"><slot></slot></p>
  </div>
</template>

<script>
export default {
  name: "AppInstruction",
  props: {
    number: {
      type: [String, Number],
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.instruction {
  position: relative;
  padding-left: 30px;

  &--number {
    position: absolute;
    top: 50%;
    left: 0;
    width: 24px;
    height: 24px;
    transform: translate(0 , -50%);
    background-color: transparentize($dark-grey, 0.5);
    border-radius: 50%;
    font-weight: bold;
    color: $white;
    text-align: center;
    line-height: 24px;
  }

  &--text {
    position: relative;
    padding: 0.5rem 1rem;
    border-left: 1px solid $border;
    line-height: 1.3;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      width: 6px;
      border-bottom: 1px solid $border;
      transform: translateY(-50%);
    }
  }
}
</style>
